<template>
  <NumberField
    :id="`transact-port`"
    name="keystore.port"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.transactPort')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.transactPortPlaceholder')"
    :useGrouping="false"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
